import storageScheme from '@/lib/storage-scheme'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: storageScheme.getItem('loloyal-language'),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: ['translation', 'constant'],
  })

export default i18n
